import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Stack,
  TrendIndicator,
} from '@shared/ui';

export function TrendIndicatorShowcase() {
  const { t } = useTranslation();
  const context = t('uiLibrary.feedback.trendIndicator.labels.vsAvg', 'vs avg');

  const accessibleLabel = (
    direction: 'up' | 'down' | 'flat',
    value: string,
    sentiment: 'positive' | 'neutral' | 'negative'
  ) => {
    const directionLabel = t(`common.trend.direction.${direction}`, direction);
    const sentimentLabel = t(`common.trend.sentiment.${sentiment}`, sentiment);
    return `${directionLabel}: ${value} ${context}; ${sentimentLabel}`;
  };

  return (
    <Card data-testid="trend-indicator-showcase">
      <CardHeader>
        <CardTitle>{t('uiLibrary.feedback.trendIndicator.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.feedback.trendIndicator.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <Stack gap="sm">
          <TrendIndicator
            accessibleLabel={accessibleLabel('up', '+7.49%', 'positive')}
            context={context}
            direction="up"
            sentiment="positive"
            sentimentLabel={t('common.trend.sentiment.positive', 'positive')}
            value="+7.49%"
          />
          <TrendIndicator
            accessibleLabel={accessibleLabel('down', '-7.12%', 'negative')}
            context={context}
            direction="down"
            sentiment="negative"
            sentimentLabel={t('common.trend.sentiment.negative', 'negative')}
            value="-7.12%"
          />
          <TrendIndicator
            accessibleLabel={accessibleLabel('flat', '0.00%', 'neutral')}
            context={context}
            direction="flat"
            sentiment="neutral"
            sentimentLabel={t('common.trend.sentiment.neutral', 'neutral')}
            value="0.00%"
          />
          <TrendIndicator
            accessibleLabel={accessibleLabel('up', '+12.40%', 'positive')}
            appearance="badge"
            context={context}
            direction="up"
            sentiment="positive"
            sentimentLabel={t('common.trend.sentiment.positive', 'positive')}
            value="+12.40%"
          />
          <TrendIndicator
            accessibleLabel={accessibleLabel('down', '-12.40%', 'positive')}
            appearance="badge"
            context={context}
            direction="down"
            sentiment="positive"
            sentimentLabel={t('common.trend.sentiment.positive', 'positive')}
            value="-12.40%"
          />
        </Stack>
      </CardContent>
    </Card>
  );
}
